import { api } from '@/core/api/';

const baseApiURL = 'api/providers/sifdevendor';

export const getVendorInfo = (companyId, contractNumber, syncInfo) => {
  return api.get(`${baseApiURL}/vendorinfo`, {
    params: {
      companyId,
      contractNumber,
      syncInfo,
    },
  });
};

export const getAcademicYears = () => api.get(`${baseApiURL}/academicyears`);

export const updatePurchaseOrderDetails = (purchaseOrderId, budgetRef) =>
  api.put(`${baseApiURL}/updatepodetail/${purchaseOrderId}/${budgetRef}`);

export const updateVoucherBill = (voucherNumber, billId) =>
  api.put(`${baseApiURL}/updatevoucherbill/${voucherNumber}/${billId}`);
